// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"3f5e65ce","784":"c137b87b"}[chunkId] + ".chunk.css";
};